import React from 'react';
import { clsx } from 'clsx';

import { Link } from '../../components';
import { PermissionCheck } from '../../shared';
import type { MenuItem as MenuItemType } from './MainLayout';

type NavItemProps = {
  menuItem: MenuItemType;
  className?: string;
  linkClassName?: string;
  activeClassName?: string;
  onClick?: () => void;
};

export const NavItem: React.FC<NavItemProps> = ({
  menuItem: item,
  linkClassName = 'text-small',
  className = 'flex items-center',
  activeClassName = '',
  onClick,
}) => {
  const element = item.url ? (
    <Link
      key={item.text || item.url}
      url={item.url || '#'}
      activeClassName={activeClassName}
      className={clsx(
        linkClassName,
        'hover:text-main transition px-md font-semibold'
      )}
      onClick={onClick}
    >
      <div className="flex items-center justify-center">
        {item.icon && (
          <div className="flex items-center justify-center font-medium">
            {item.icon}
          </div>
        )}
        <div>{item.text}</div>
      </div>
    </Link>
  ) : (
    <button
      onClick={() => {
        item.onClick?.();
        onClick?.();
      }}
      className={clsx(className, linkClassName)}
    >
      {item.icon && (
        <span className="flex items-center justify-center text-lg mr-2">
          {item.icon}
        </span>
      )}
      <span>{item.text}</span>
    </button>
  );

  return item.action ? (
    <PermissionCheck action={item.action}>{element}</PermissionCheck>
  ) : (
    element
  );
};
